<!--
 * @Author: your name
 * @Date: 2020-10-15 17:14:27
 * @LastEditTime: 2020-10-22 16:38:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zhulogic-design-cloud-next/src/views/workLocation/index.vue
-->
<template>
  <div class="work-location">
    <div class="img">
      <img
        src="https://oss.zhulogic.com/planImage/fa/877_dir/2fanAsTR2NSGN3ytSeW6XpjcX7P6c7B3G7.png"
        alt=""
      />
    </div>
    <div class="work-location-main pageWidtn">
      <Row>
        <Col span="12" class="img-view">
          <router-link to="/find-work">
            <img
              src="https://oss.zhulogic.com/planImage/fa/877_dir/WKfYxrBprAQYET4Pbc2wkC32aJedG4ktWX.png"
              alt=""
            />
            <div>
              <Button
                class="red-btn"
                type="primary"
                style="margin-top:50px;width:200px"
                >我要找工作</Button
              >
            </div>
          </router-link>
        </Col>
        <Col span="12" class="img-view">
          <router-link to="/worker-list">
            <img
              src="https://oss.zhulogic.com/planImage/fa/877_dir/RGn4riCWP2bahcQkpkRE87y33QYweBD7aB.png"
              alt=""
            />
            <div>
              <Button
                class="red-btn"
                type="primary"
                style="margin-top:50px;width:200px"
                >我要招人</Button
              >
            </div>
          </router-link>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.work-location {
  background: #f3f5f9;
  padding-bottom: 160px;
  .img {
    width: 100%;
    max-height: 268px;
    min-height: 200px;
    overflow: hidden;
    > img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .work-location-main {
    margin-top: 160px;
    .img-view {
      text-align: center;
      img {
        width: 300px;
        height: 188px;
      }
    }
  }
}
</style>
